import { useTranslation } from 'react-i18next';
import 'react-datepicker/dist/react-datepicker.css';
import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TransactionDataPanel } from '../../components/Transactions/TransactionDataPanel';
import { TransactionsTabs } from '../../components/Transactions/TransactionsTabs';
import { PageHeader } from '../../components/ui/PageHeader';
import { useTransactionResources } from '../../hooks/useTransactionResources';
import { getTransactionCounts } from '../../utils/transactionDataApi';
import { useSession } from '../../context/SessionContext';

export const Transactions = () => {
  const { t } = useTranslation();
  const { role } = useSession();

  const [refreshVersion, setRefreshVersion] = useState(0);
  const [tabNum, setTabNum] = useState('1');
  const [counts, setCounts] = useState({ pending: 0, createApproval: 0, updateApproval: 0 });
  const [searchParams] = useSearchParams();
  const hasLinkedFilters = Boolean(searchParams.get('customer_id') || searchParams.get('supplier_id'));
  const {
    customers,
    suppliers,
    filtersLoading,
    filtersLoaded,
    loadFilters,
  } = useTransactionResources({ preloadFilters: true });

  const refreshTransactions = useCallback(() => setRefreshVersion((value) => value + 1), []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getTransactionCounts();
      if (response?.status < 400) setCounts(response.data);
    };

    const timeoutId = window.setTimeout(fetchData, refreshVersion === 0 ? 1500 : 0);
    return () => window.clearTimeout(timeoutId);
  }, [refreshVersion]);

  const panelMode = { '1': 'all', '2': 'pending', '3': 'createApproval', '4': 'updateApproval' }[tabNum];

  return (
    <div>
      <PageHeader
        title={t('Transactions')}
        description={t('Create, review, approve, export, and reconcile invoice activity.')}
      />
      <div className='tabs sm:rounded-[var(--radius-md)] sm:border sm:border-[var(--border-subtle)] sm:bg-[var(--surface-panel)] sm:p-4 sm:shadow-sm'>
        <TransactionsTabs activeKey={tabNum} counts={counts} onChange={setTabNum} t={t} />
        <TransactionDataPanel
          key={panelMode}
          mode={panelMode}
          customers={customers}
          suppliers={suppliers}
          role={role}
          filtersLoading={filtersLoading}
          filtersLoaded={filtersLoaded}
          loadFilters={loadFilters}
          hasLinkedFilters={hasLinkedFilters}
          refreshVersion={refreshVersion}
          onRefresh={refreshTransactions}
        />
      </div>
    </div>
  );
};
